import { render, staticRenderFns } from "./OptionsAdvancedProps.vue?vue&type=template&id=06d36a6f"
import script from "./OptionsAdvancedProps.vue?vue&type=script&lang=js"
export * from "./OptionsAdvancedProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports